/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Choose_TemplateInputs */

const en_resume_editor_choose_template = /** @type {(inputs: Resume_Editor_Choose_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose Template`)
};

const de_resume_editor_choose_template = /** @type {(inputs: Resume_Editor_Choose_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlage waehlen`)
};

const fr_resume_editor_choose_template = /** @type {(inputs: Resume_Editor_Choose_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir un modele`)
};

const es_resume_editor_choose_template = /** @type {(inputs: Resume_Editor_Choose_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir plantilla`)
};

const it_resume_editor_choose_template = /** @type {(inputs: Resume_Editor_Choose_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli modello`)
};

const nl_resume_editor_choose_template = /** @type {(inputs: Resume_Editor_Choose_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjabloon kiezen`)
};

const pl_resume_editor_choose_template = /** @type {(inputs: Resume_Editor_Choose_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz szablon`)
};

const fi_resume_editor_choose_template = /** @type {(inputs: Resume_Editor_Choose_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse malli`)
};

const da_resume_editor_choose_template = /** @type {(inputs: Resume_Editor_Choose_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaelg skabelon`)
};

const sv_resume_editor_choose_template = /** @type {(inputs: Resume_Editor_Choose_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valj mall`)
};

/**
* | output |
* | --- |
* | "Choose Template" |
*
* @param {Resume_Editor_Choose_TemplateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_choose_template = /** @type {((inputs?: Resume_Editor_Choose_TemplateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Choose_TemplateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_choose_template(inputs)
	if (locale === "fr") return fr_resume_editor_choose_template(inputs)
	if (locale === "es") return es_resume_editor_choose_template(inputs)
	if (locale === "it") return it_resume_editor_choose_template(inputs)
	if (locale === "nl") return nl_resume_editor_choose_template(inputs)
	if (locale === "pl") return pl_resume_editor_choose_template(inputs)
	if (locale === "fi") return fi_resume_editor_choose_template(inputs)
	if (locale === "da") return da_resume_editor_choose_template(inputs)
	if (locale === "sv") return sv_resume_editor_choose_template(inputs)
	return en_resume_editor_choose_template(inputs)
});